import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for deleting an AVP chart.
 */
export type AvpChartDeleteData = {
	/**
	 * The ARI of the AVP dashboard to delete the chart from.
	 */
	dashboardAri: string;
	/**
	 * The identifier of the chart to delete.
	 */
	chartId: string;
	/**
	 * The canvas layout configuration.
	 */
	canvasLayout: SerializableValue;
};

/**
 * Properties for the AVP chart deletion command.
 *
 * @extends CommandProperties
 */
export interface AvpChartDeleteCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the chart deletion request.
	 */
	key: string;
	/**
	 * The data payload containing the identifiers for the chart to delete.
	 */
	data: AvpChartDeleteData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to delete an AVP chart.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to delete an AVP chart with the specified identifiers.
 */
export const AvpChartDeleteCommand: CommandConstructor<
	AvpChartDeleteCommandProperties,
	SerializableValue
> = createCommand<AvpChartDeleteCommandProperties>('avp-chart-delete-command');
